import { DiscogsSearchArtistsInnerExternalIdsInner } from 'shared_components/generated/admin';
import { ArtistImageNotFound } from './ArtistImageNotFound';
import { useMemo } from 'react';
import { ArtistDiscogImage } from './ArtistDiscogImage';

export function ArtistMusicbrainzImage({
  externalIds,
  title,
}: {
  readonly title: string;
  readonly externalIds: DiscogsSearchArtistsInnerExternalIdsInner[];
}) {
  const discog_id = useMemo(
    () => externalIds.find((externalId) => externalId.source === 'discogs')?.id,
    [externalIds]
  );

  if (discog_id)
    return <ArtistDiscogImage discogId={discog_id} title={title} />;

  return <ArtistImageNotFound />;
}
